export const COMPANY = "Company";
export type COMPANY_TYPE = "Company";
export const APPLICANT = "Applicant";
export type APPLICANT_TYPE = "Applicant";
export const OFFER = "Offer";
export type OFFER_TYPE = "Offer";
export const JOB_APPLICATION = "JobApplication";
export type JOB_APPLICATION_TYPE = "JobApplication";
export * from "./CompanyNotification";
export * from "./ApplicantNotification";
export * from "./AdminNotification";
